import { createContext, useContext } from 'react';

/**
 * Context used by ConfigurationTabsLayout to pass tab navigation controls
 * into ConfigCrudPage / ApiTablePage so that tabs are rendered inside the
 * table toolbar instead of above it.
 */
export const ConfigTabsContext = createContext(null);

export const useConfigTabs = () => useContext(ConfigTabsContext);
